<template>
  <div>
    <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
    <ListagemPedidos
        v-show="!mostrarDetalhe"
        :itens="listaPedidos"
        :colunas="fields"
        :estaCarregando="desabilitarCampos"
        :modoInline="true">
        <template #servico="{ item }">
          <a href="#" class="linkr" @click.prevent="selecionarPedido(item)">
                {{ item.descricao }}
          </a>
        </template>
    </ListagemPedidos>
    <spinnerProcessando
        v-if="carregandoDetalhe"
        cssClass="ml-2"
        :status="true"
        mensagem="Carregando detalhes do pedido..."
    />
    <DetalhePedido v-if="mostrarDetalhe && !carregandoDetalhe" :pedido-id="pedidoSelecionado.id" @voltar="voltarParaListagem" />
  </div>
</template>

<script>
import Pedidos from './js/pedidos'
import DetalhePedido from './DetalhePedido.vue'
import ListagemPedidos from '../pedidos/ListagemPedidos.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'

export default {
  ...Pedidos,
  components: {
    DetalhePedido,
    ListagemPedidos,
    spinnerProcessando
  },
  data () {
    return {
      ...Pedidos.data(),
      mostrarDetalhe: false,
      pedidoSelecionado: null,
      carregandoDetalhe: false
    }
  },
  methods: {
    ...Pedidos.methods,
    async selecionarPedido (pedido) {
      this.carregandoDetalhe = true
      this.pedidoSelecionado = pedido
      await new Promise(resolve => setTimeout(resolve, 100))
      this.mostrarDetalhe = true
      this.carregandoDetalhe = false
    },
    voltarParaListagem () {
      this.mostrarDetalhe = false
      this.pedidoSelecionado = null
      this.carregandoDetalhe = false
    }
  }
}
</script>
